export default __webpack_public_path__ + "static/media/success.f2eef1d1.webp";